import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  actionsMenu: {
    paddingBottom: theme.spacing(1.25),
    paddingTop: theme.spacing(1.25),
  },
}));
